/* Dieselino — автопрокрутка слайдера, которая переживает касание.
 *
 * Тема создаёт Swiper с disableOnInteraction: true (жёстко в app.min.js), то
 * есть первое же касание слайдера навсегда выключает автолистание. На телефоне
 * это случается почти сразу — палец по баннеру при скролле уже считается
 * взаимодействием — и дальше слайды двигаются только кнопками.
 *
 * Swiper читает этот флаг в момент касания, а не при инициализации, поэтому
 * достаточно поправить params после старта: автопрокрутка приостанавливается на
 * время жеста и сама возобновляется после него.
 *
 * Отдельным файлом, а не правкой app.min.js: тот бандл вендорский.
 */
(function () {
  'use strict';

  var SECTION = '.home-banner__slideshow';
  var POLL_MS = 200;
  var POLL_LIMIT = 75; /* ~15с: swiper поднимается после loadAssets */

  function attach(section) {
    var container = section.querySelector('.swiper-container');
    if (!container || container.dataset.autoplayPatched) return true;

    var swiper = container.swiper;
    if (!swiper || !swiper.params || !swiper.params.autoplay) return false;

    container.dataset.autoplayPatched = 'true';
    swiper.params.autoplay.disableOnInteraction = false;

    /* Если касание уже успело её погасить до того, как мы сюда добрались. */
    if (swiper.autoplay && !swiper.autoplay.running) swiper.autoplay.start();
    return true;
  }

  function watch(section) {
    if (attach(section)) return;

    var tries = 0;
    var timer = setInterval(function () {
      if (attach(section) || ++tries >= POLL_LIMIT) clearInterval(timer);
    }, POLL_MS);
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SECTION), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Редактор тем перерисовывает секцию целиком — цепляемся заново. */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
